const ERROR_MESSAGE = 'Input is not a valid URL';
const NO_HTTP_OR_HTTPS_URL_PATTERN = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function noHttpProtocolRule(value: any): string | true {
    return NO_HTTP_OR_HTTPS_URL_PATTERN.test(value) || ERROR_MESSAGE;
}
